// export const textFieldStyles = (width = "30%") => ({
//     backgroundColor: "white",
//     mr: 3,
//     width: width,
//     borderRadius: "8px",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//     marginTop: "0",
//     marginBottom: "0",
//     "& .MuiOutlinedInput-root": {
//     //   borderRadius: "0px", // Border radius for the input field
//       "& .MuiOutlinedInput-notchedOutline": {
//         // border: "none", // Remove border
//         // OR use this to just change border radius:
//         borderRadius: "8px",
//       },
//       "&:hover .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#1976d2",
//         boxShadow: "0 2px 4px rgba(25,118,210,0.25)"
//       },
//       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#1976d2",
//         boxShadow: "0 2px 4px rgba(25,118,210,0.25)"
//       }
//     }
// });
// In styles/textFieldStyles.js

import { typoBase } from "./typography";

export const textFieldStyles = (
  width = "100%",
  mt = "0",
  marginBottom = "0",
  marginRight = "24px"
) => ({
  mr: marginRight,
  mt: mt,
  mb: marginBottom,
  width: width,
  borderRadius: "0px",
  fontSize: "11.5px",
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    // marginTop: "0",
  // marginBottom: 3,
  "& .MuiOutlinedInput-root": {
    borderRadius: "0px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
    transition: "all 0.2s",
    ...typoBase,
    fontSize: "11.5px",
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#fafafa",
    },
    "&.Mui-focused": {
      backgroundColor: "#f0f7ff",
      boxShadow: "0 2px 5px rgba(0,103,192,0.05)",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#d1d1d1",
      borderWidth: "1px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#858585",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#0067C0",
      borderWidth: "2px",
    },
  },
  "& .MuiInputLabel-root": {
    // Add label styles
    ...typoBase,
    color: "#616161",
    fontSize: "11.5px",
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    
  },
  "& .MuiInputLabel-root.Mui-focused": {
    // Focused label styles
    color: "#0067C0",
  },
  "& .MuiFormHelperText-root": {
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
    marginTop: "2px",
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
});

export const textFieldStylesWithoutBorder = (
  width = "100%",
  mt = "0",
  marginBottom = "0",
  marginRight = "24px"
  
) => ({
  mr: marginRight,
  mt: mt,
  mb: marginBottom,
  width: width,
  borderRadius: "0px",
  // marginTop: "0",
  // marginBottom: 3,
  "& .MuiOutlinedInput-root": {
    borderRadius: "0px",
    backgroundColor: "#ffffff",
    transition: "all 0.2s",
    ...typoBase,
    fontSize: "11.5px",
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    
    color: "#000000",
    "&:hover": {
      backgroundColor: "#fafafa",
    },
    // "&.Mui-focused": {
    //   backgroundColor: "#f0f7ff",
    //   boxShadow: "0 2px 5px rgba(0,103,192,0.05)"
    // },
    "& .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#d1d1d1",
      // borderWidth: "1px",
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#858585",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#0067C0",
      borderWidth: "2px",
    },
  },
  "& .MuiInputLabel-root": {
    // Add label styles
    ...typoBase,
    fontSize: "11.5px",
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    
    color: "#616161",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    // Focused label styles
    color: "#0067C0",
  },
  "& .MuiFormHelperText-root": {
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
    marginTop: "4px",
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
});
